export default class PartnerTypes {
  static attacking = "ATTACKING";
  static ancillary = 'ANCILLARY';
  static balanced = 'BALANCED';
  static overloading = 'OVERLOADING';
}
